module.exports = __webpack_public_path__ + "static/media/W3.d477a4fe.jpg";